<div>
    <div class="row">
        <div class="col-xl-12">
            <div class="card-box">
                <div v-show="!loading">
                    <data-table :headings="customerPricingHeadings" :data="customerPricing" :hasActions="true"
                                :pagingDetails="pagingDetails"
                                :stateChanged="filterStateChanged"
                                @actionClicked="onPricingActionClicked" @filterSearchClicked="onFilterSearchClicked">
                        <template #actionButton>
                            <div class="w-100">
                                <router-link
                                        class="btn btn-primary"
                                        to="/pricing/delivery/addCustomerGroupPricingForZone">
                                    Add Pricing
                                </router-link>
                            </div>
                        </template>
                        <template #filter>
                            <div class="p-3">
                                <div class="input-group pb-4">
                                    <input type="text" class="form-control" placeholder="Search" aria-label="Search" aria-describedby="basic-addon1" v-model="filter.customerSearchQuery">
                                    <div class="input-group-append">
                                    <span class="input-group-text" id="basic-addon1">
                                        <i class="fas fa-search"></i>
                                    </span>
                                    </div>
                                </div>
                                <div class="row">
<!--                                    <div class="col-6">-->
<!--                                        <label>Zones</label>-->
<!--                                        <bootstrap-select  :selectOptions="zones" :selectedOption="filter.zoneId" :elementId="'zoneFilterSelect'"-->
<!--                                                           :returnSelectedOptionText="true"-->
<!--                                                           @changeSelect="onZoneFilterSelect"></bootstrap-select>-->
<!--                                    </div>-->
                                    <div class="col-12">
                                        <label>Customers</label>
                                        <bootstrap-select  :selectOptions="customers" :selectedOption="filter.customerId" :elementId="'customerFilterSelect'"
                                                           :returnSelectedOptionText="true"
                                                           @changeSelect="onCustomerFilterSelect"></bootstrap-select>
                                    </div>
                                </div>
                                <br>
                                <div class="row">
                                    <div class="col-6">
                                        <label>Products</label>
                                        <bootstrap-select  :selectOptions="products" :selectedOption="filter.productId" :elementId="'productFilterSelect'"
                                                           :returnSelectedOptionText="true"
                                                           @changeSelect="onProductFilterSelect"></bootstrap-select>
                                    </div>
                                    <div class="col-6">
                                        <active-inactive-radio-buttons :activeInactiveKey="filter.activeOrInactiveItems"
                                                                       :componentId="'productFilterRadioButtons'"
                                                                       @activeInactiveSelected="onActiveInactiveFilterSelected"></active-inactive-radio-buttons>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </data-table>
                </div>
                <loading-spinner :showSpinner="loading"></loading-spinner>
            </div>
        </div>
    </div>

    <mark-as-active-inactive-modal
                :heading="productMarkAsActiveInactiveModal.heading"
                :modalId="productMarkAsActiveInactiveModal.modalId"
                :isSaving="productMarkAsActiveInactiveModal.isSaving"
                :showModal="productMarkAsActiveInactiveModal.showModal"
                :isActive="productMarkAsActiveInactiveModal.isActive"
                @closeClicked="productMarkAsActiveInactiveModal.showModal = false"
                @saveButtonClicked="onMarkAsActiveInactiveSaveClick"></mark-as-active-inactive-modal>
    
</div>
